import React from "react";
import { Layout, Menu } from "antd";
import {
  UserOutlined,
  PieChartOutlined,
  ProfileOutlined,
  MessageOutlined,
  HistoryOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import "./layout.scss";
import LogoImg from "../../assets/header_logo.png";
import ProfileImg from "../../assets/profile.png";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";

const { Sider } = Layout;

const ShowByType = (match) => {
  if (localStorage["type"] == "accountant") {
    return (
      <React.Fragment>
        <Menu.Item key="2">
          <Link to={`${match.path}/profile`}>
            <UserOutlined /> الملف الشخصي
          </Link>
        </Menu.Item>
        <Menu.Item key="3">
          <Link to={`${match.path}/assigned-requests`}>
            <ProfileOutlined /> الطلبات المسندة إليه
          </Link>
        </Menu.Item>
        <Menu.Item key="5">
          <Link to={`${match.path}/requests-history`}>
            <HistoryOutlined /> سجل الطلبات
          </Link>
        </Menu.Item>
        <Menu.Item key="6">
          <Link to={`/login`}>
            <LogoutOutlined /> تسجيل الخروج
          </Link>
        </Menu.Item>
      </React.Fragment>
    );
  } else if (localStorage["type"] == "applicant") {
    return (
      <React.Fragment>
        <Menu.Item key="7">
          <Link to={`${match.path}/apply-request`}>
            <ProfileOutlined /> تقديم طلب
          </Link>
        </Menu.Item>
        <Menu.Item key="2">
        <Link to={`${match.path}/profile`}>
          <UserOutlined /> الملف الشخصي
        </Link>
      </Menu.Item>
        <Menu.Item key="3">
          <Link to={`${match.path}/assigned-requests`}>
            <ProfileOutlined /> الطلبات
          </Link>
        </Menu.Item>
        <Menu.Item key="5">
        <Link to={`${match.path}/requests-history`}>
          <HistoryOutlined /> سجل الطلبات
        </Link>
      </Menu.Item>
    
        <Menu.Item key="6">
          <Link to={`/login`}>
            <LogoutOutlined /> تسجيل الخروج
          </Link>
        </Menu.Item>
      </React.Fragment>
    );
  } else if (localStorage["type"] == "evalutor") {
    return (
      <React.Fragment>
        <Menu.Item key="1">
          <Link to={`${match.path}/statistics-reports`}>
            <PieChartOutlined /> إحصائيات وتقارير
          </Link>
        </Menu.Item>
        <Menu.Item key="2">
          <Link to={`${match.path}/profile`}>
            <UserOutlined /> الملف الشخصي
          </Link>
        </Menu.Item>
        <Menu.Item key="3">
          <Link to={`${match.path}/assigned-requests`}>
            <ProfileOutlined /> الطلبات المسندة إليه
          </Link>
        </Menu.Item>
        <Menu.Item key="5">
          <Link to={`${match.path}/requests-history`}>
            <HistoryOutlined /> سجل الطلبات
          </Link>
        </Menu.Item>
        <Menu.Item key="6">
          <Link to={`/login`}>
            <LogoutOutlined /> تسجيل الخروج
          </Link>
        </Menu.Item>
      </React.Fragment>
    );
  } else if (localStorage["type"] == "ceo") {
    return (
      <React.Fragment>
        <Menu.Item key="1">
          <Link to={`${match.path}/statistics-reports`}>
            <PieChartOutlined /> إحصائيات وتقارير
          </Link>
        </Menu.Item>
        <Menu.Item key="2">
          <Link to={`${match.path}/profile`}>
            <UserOutlined /> الملف الشخصي
          </Link>
        </Menu.Item>
        <Menu.Item key="3">
          <Link to={`${match.path}/assigned-requests`}>
            <ProfileOutlined /> الطلبات المسندة إليه
          </Link>
        </Menu.Item>

        <Menu.Item key="5">
          <Link to={`${match.path}/requests-history`}>
            <HistoryOutlined /> سجل الطلبات
          </Link>
        </Menu.Item>
        <Menu.Item key="6">
          <Link to={`/login`}>
            <LogoutOutlined /> تسجيل الخروج
          </Link>
        </Menu.Item>
      </React.Fragment>
    );
  } else if (localStorage["type"] == "chairman") {
    return (
      <React.Fragment>
        <Menu.Item key="1">
          <Link to={`${match.path}/statistics-reports`}>
            <PieChartOutlined /> إحصائيات وتقارير
          </Link>
        </Menu.Item>
        <Menu.Item key="2">
          <Link to={`${match.path}/profile`}>
            <UserOutlined /> الملف الشخصي
          </Link>
        </Menu.Item>
        <Menu.Item key="3">
          <Link to={`${match.path}/assigned-requests`}>
            <ProfileOutlined /> الطلبات المسندة إليه
          </Link>
        </Menu.Item>

        <Menu.Item key="5">
          <Link to={`${match.path}/requests-history`}>
            <HistoryOutlined /> سجل الطلبات
          </Link>
        </Menu.Item>
        <Menu.Item key="6">
          <Link to={`/login`}>
            <LogoutOutlined /> تسجيل الخروج
          </Link>
        </Menu.Item>
      </React.Fragment>
    );
  } else if (localStorage["type"] == "superadmin") {
    return (
      <React.Fragment>
          <Menu.Item key="7">
          <Link to={`${match.path}/apply-request`}>
            <ProfileOutlined /> تقديم طلب
          </Link>
        </Menu.Item>

        <Menu.Item key="10">
        <Link to={`${match.path}/update-cretria`}>
          <ProfileOutlined /> تحديث معايير الدعم
        </Link>
      </Menu.Item>

        <Menu.Item key="1">
          <Link to={`${match.path}/statistics-reports`}>
            <PieChartOutlined /> إحصائيات وتقارير
          </Link>
        </Menu.Item>

        <Menu.Item key="3">
          <Link to={`${match.path}/assigned-requests`}>
            <ProfileOutlined /> كل الطلبات
          </Link>
        </Menu.Item>

        <Menu.Item key="9">
          <Link to={`${match.path}/all-users`}>
          <UserOutlined />كل المستخدمين
          </Link>
        </Menu.Item>

        <Menu.Item key="5">
          <Link to={`${match.path}/requests-history`}>
            <HistoryOutlined /> سجل الطلبات
          </Link>
        </Menu.Item>

        <Menu.Item key="6">
          <Link to={`/login`}>
            <LogoutOutlined /> تسجيل الخروج
          </Link>
        </Menu.Item>
      </React.Fragment>
    );
  } else {
  }
};

const PagesLayout = ({ children, match, defaultKey, menuOpened }) => {
  console.log("match", defaultKey, match, menuOpened);
  const width = window.innerWidth;
  return (
    <Layout className="layout-container">
      <Layout className="insider-layout">
        {width > 1024 && menuOpened ? (
          <Sider width={250} className="site-layout-background">
            <div className="image-name-container">
              <img
                src={LogoImg}
                alt="shawi logo"
                className="logo-shawi-square-bg"
              />
              <div className="profile-data">
                <img
                  src={ProfileImg}
                  alt="profile"
                  className="profile-img-cricle"
                />
                <h3>{localStorage["name"]}</h3>
                <p>{localStorage["role"]}</p>
              </div>
            </div>
            <Menu
              mode="inline"
              selectedKeys={[defaultKey + ""]}
              defaultOpenKeys={["sub1"]}
              style={{ borderRight: 0 }}
            >
              {ShowByType(match)}
            </Menu>
          </Sider>
        ) : null}

        <Layout
          style={{
            padding: "40px 40px 0 24px",
            borderTopRightRadius: "30px",
            borderBottomRightRadius: "30px",
          }}
        >
          {children}
        </Layout>
      </Layout>
    </Layout>
  );
};

const mapStateToProps = ({ layout }) => ({
  menuOpened: layout.opened,
});
export default withRouter(connect(mapStateToProps)(PagesLayout));
